<template>
  <div>
    <div class="main-wrapper">
      <!-- 年份选择  店铺选择 -->
      <header-select-bar v-model="formData" @change="handleHeaderChange" @refresh="handleRefresh"></header-select-bar>
      <!-- {{formData}}{{formatFormData}} -->
      <!-- 月份选择 -->
      <div v-if="formData.year && formData.storeId" :key="'month-' + componentKey">
        <month-select-bar
          ref="month"
          v-model="planTime"
          :data="formData"
          @change="handleMonthChange"
          @changeYear="addListenerYear">
        </month-select-bar>
      </div>
      <!-- {{formatFormData}} -->
      <template v-if="formatFormData.planTime">
        <tabs-bar v-model="activeTabName" :form="formatFormData" :key="'tabs-' + componentKey"></tabs-bar>
       <keep-alive :include="cachedComponents">
          <component 
            :is="activeComponent" 
            :form="formatFormData" 
            :dataUpdateObj="dataUpdateObj"
            :cachedComponents.sync="cachedComponents"
            v-if="activeTabName"
          ></component>
       </keep-alive>
      </template>
    </div>
  </div>
</template>

<script>
import headerSelectBar from './components/headerSelectBar/headerSelectBar'
import monthSelectBar from './components/monthSelectBar/monthSelectBar'
import tabsBar from './components/tabsBar/tabsBar'

import estimateAnalysis from './components/mainContent/estimateAnalysis/estimateAnalysis'
import commodity from './components/mainContent/commodity/commodity'
import product from './components/mainContent/product/product'
import productCategory from './components/mainContent/product-category/product-category'
import shopSummary from './components/mainContent/shop-summary/shop-summary'
import packages from './components/mainContent/packages/packages'
import newProduct from './components/mainContent/new-product/new-product'
import whiteList from './components/mainContent/white-list/white-list'
import aClass from './components/mainContent/aClass/aClass'
import abnormalGoods from './components/mainContent/abnormalGoods/abnormalGoods'
import abnormalProduct from './components/mainContent/abnormalProduct/abnormalProduct'
import pagePathMixin from '@/utils/page-path-mixin'
const componentList = [];
export default {
  name: "PreSalePlanNew",
  mixins: [pagePathMixin],
  components: {
    headerSelectBar,
    monthSelectBar,
    tabsBar,
    estimateAnalysis,
    commodity,
    product,
    productCategory,
    shopSummary,
    packages,
    newProduct,
    whiteList,
    aClass,
    abnormalGoods,
    abnormalProduct
  },
  data() {
    return {
      formData: {
        year: new Date().getFullYear()
      },
      planTime: null,
      activeTabName: '',
      updateData: [],
      cachedComponents: [],
      componentKey: 0, // 用于强制重新渲染整个组件
      isRefreshing: false, // 标记是否正在刷新
      refreshTargetTab: '' // 刷新后要恢复的标签页
    }
  },
  computed: {
    activeComponent() {
      if(this.activeTabName) {
        return this.activeTabName
      }else{
        return ''
      }
    },
    formatFormData() {
      let formData = JSON.parse(JSON.stringify(this.formData));
      formData['planTime'] = this.planTime;
      delete formData['year']
      return formData
    },
    // 数据刷新时间
    dataUpdateObj() {
      if(!this.updateData.length) return {};
      switch(this.activeTabName) {
        case 'commodity':
          return this.updateData.filter(v=>v.dataTpe === '15')[0]
        case 'product':
          return this.updateData.filter(v=>v.dataTpe === '16')[0]
        case 'packages':
          return this.updateData.filter(v=>v.dataTpe === '17')[0]
        case 'newProduct':
          return this.updateData.filter(v=>v.dataTpe === '4')[0]
        case 'aClass':
          return this.updateData.filter(v=>v.dataTpe === '5')[0]
      }
    }
  },
  watch: {
    activeTabName(val) {
      if(this.cachedComponents.indexOf(val) == -1) {
        this.$nextTick(() => {
          this.cachedComponents.push(val)
        });
        
      }
    },
    // 监听 planTime 变化，在刷新过程中等待其更新完成
    planTime(newVal, oldVal) {
      // 如果正在刷新，且 planTime 从 null 变为有值，说明月份已经重新初始化完成
      if (this.isRefreshing && newVal && !oldVal) {
        this.$nextTick(() => {
          // 恢复之前选择的标签页
          if (this.refreshTargetTab) {
            this.activeTabName = this.refreshTargetTab;
          }
          // 触发页面内容刷新
          setTimeout(() => {
            this.$bus.$emit('refresh', null);
          }, 100);
          // 重置刷新状态
          this.isRefreshing = false;
          this.refreshTargetTab = '';
        });
      }
    }
  },
  created() {
    this.get_getDataRenewal();
  },
  methods: {
    // 监听事件 日期、平台change
    handleHeaderChange(data) {
      this.cachedComponents = [];
      // 先更新月份，获取到最新的planTime再刷新页面
      this.$bus.$emit('monthRefresh', null);
      setTimeout(_=>{
        this.$bus.$emit('refresh', null);
      },300)
    },
    // 监听事件 月份change
    handleMonthChange(data) {
      setTimeout(_=>{
        this.$bus.$emit('refresh', null);
      },300)
      this.cachedComponents = [];
    },
    // 监听事件 跨年份
    addListenerYear(status) {
      if(status){
        this.$set(this.formData, 'year', +this.formData.year+1);
      }else{
        this.$set(this.formData, 'year', +this.formData.year-1);
      }
    },
    get_getDataRenewal() {
      this.$q.preSalePlan.getDataRenewal()
      .then(res=>{
        this.updateData = res.data;
      })
    },
    // 处理刷新按钮点击 - 完全初始化整个页面
    handleRefresh() {
      // 1. 设置刷新状态，保存当前选择的标签页
      this.isRefreshing = true;
      this.refreshTargetTab = this.activeTabName;
      
      // 2. 清空缓存的组件，强制重新渲染
      this.cachedComponents = [];
      
      // 3. 重置活动标签（先清空，避免旧数据影响）
      this.activeTabName = '';
      
      // 4. 重置月份选择（watch 会监听 planTime 的变化）
      this.planTime = null;
      
      // 5. 强制重新渲染所有组件
      this.componentKey += 1;
      
      // 6. 重新获取最新刷新时间数据
      this.get_getDataRenewal();
      
      // 7. 等待组件重新渲染后，重新初始化月份
      this.$nextTick(() => {
        if (this.$refs.month) {
          // 触发月份组件的 init 方法，会重新设置 planTime
          // planTime 更新后会触发 watch，自动恢复标签页
          this.$bus.$emit('monthRefresh', null);
        }
      });
      
      // 8. 提示用户
      this.$message.success('页面已刷新');
    }
  }
}
</script>

<style lang="stylus" scoped>
  .main-wrapper
    height calc(100vh - 85px)
    padding 10px
    box-sizing border-box

  >>> .el-container
    background #ffffff

  .empty-ele
    height 500px
    background #ffffff
</style>
